<ng-container *ngLet="langChange$ | async">
  <div [class.impaired]="isImpaired" class="container" *ngLet="breakPointObserve$ | async">
    <ng-container *ngLet="loadingData$ | async as loading">
      <app-loader *ngIf="!isImpaired" [style.display]="!loading ? 'none' : ''"></app-loader>
      <div [style.display]="loading ? 'none' : ''" class="wrapper" *ngLet="user$ | async">
        <ng-container *ngTemplateOutlet="isImpaired ? impairedHeader : defaultHeader"></ng-container>

        <div
          *ngLet="selectCatalog$ | async as selectCatalog"
          [ngClass]="{ 'without-map': !catalogItemId && !selectCatalog?.hasGeo, 'forms-container': step === 1 }"
        >
          <div
            class="step2"
            [style.width]="
              !catalogItemId && !selectCatalog?.hasGeo && !isImpaired
                ? 'calc(70% - var(--side-padding) - var(--side-padding))'
                : 'calc(100% - var(--side-padding) - var(--side-padding))'
            "
            [style.display]="step === 2 ? 'none' : ''"
          >
            <ng-container *ngIf="catalogItemId; else newFormTemplate">
              <ng-container *ngTemplateOutlet="IncorrectTemplate"> </ng-container>
            </ng-container>
            <div class="footer mt32 mb24">
              <span *ngIf="!isImpaired" class="caption-2">*{{ 'OTHER.REQUIRED' | translate }}</span>
              <div [class.impaired]="isImpaired" class="buttons-wrapper">
                <button [ngClass]="{ 'button2-impaired': isImpaired, 'btn-secondary medium': !isImpaired }" class="mr16" (click)="cancel()">
                  {{ 'OTHER.CANCEL' | translate }}
                </button>
                <button
                  [ngClass]="{ 'button2-impaired': isImpaired, 'btn-primary medium': !isImpaired }"
                  [disabled]="form?.invalid ?? true"
                  (click)="goStep2()"
                >
                  {{ 'OTHER.NEXT' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <app-contact-information
          [setDefaultValue]="step"
          [isImpaired]="isImpaired"
          (goStep1)="goStep1()"
          (sendSuccessfully)="appealId = $event"
          #contactInformation
          [title]="title"
          [firstStepFrom]="form"
          [hidden]="step === 1"
        ></app-contact-information>
      </div>

      <ng-template #newFormTemplate>
        <app-new-object-form [isImpaired]="isImpaired" [showMap]="!loading" [appealId]="appealId" (formInit)="formInit($event)"></app-new-object-form>
      </ng-template>
      <ng-template #IncorrectTemplate>
        <app-incorrect-data-form [isImpaired]="isImpaired" [appealId]="appealId" (formInit)="formInit($event)"></app-incorrect-data-form>
      </ng-template>

      <ng-template #defaultHeader>
        <button class="btn-empty go-back" (click)="goBack()"><svg [icon]="icons.Close" class="svg24 dark-gray-color" /></button>
        <h2 class="h2 m0">
          {{ title | translate }} <span class="primary-color" *ngIf="appealId"> {{ '№ ' + appealId }} {{ 'OTHER.CREATED' | translate }}!</span>
        </h2>
        <div class="button-container" #topButton>
          <button class="btn-secondary big tab-switcher-btn h3" [ngClass]="{ selected: step === 1 }" (click)="goStep1()">
            1. {{ 'DATA.SHARED.APPEALS.ATTRIBUTES_DATASET' | translate }}
          </button>
          <button class="btn-secondary big tab-switcher-btn h3" [ngClass]="{ selected: step === 2 }" (click)="goStep2()" [disabled]="form?.invalid">
            2. {{ 'OTHER.CONTACTS' | translate }}
          </button>
        </div>

        <div class="horizontal-line"></div>
      </ng-template>

      <ng-template #impairedHeader>
        <div class="impaired-header">
          <div class="button2-impaired-text-dark ml24">
            {{ title | translate }} <span class="primary-color" *ngIf="appealId"> {{ '№ ' + appealId }} {{ 'OTHER.CREATED' | translate }}!</span>
          </div>

          <app-impaired-icon (clickOnIcon)="goBack()" [iconName]="icons.Close" [classSize]="'big-impaired'"></app-impaired-icon>
        </div>

        <div class="button-container" #topButton>
          <button class="ml32 custom-tab small" [ngClass]="{ active: step === 1 }" (click)="goStep1()">
            1. {{ 'DATA.SHARED.APPEALS.ATTRIBUTES_DATASET' | translate }}
          </button>
          <button class="custom-tab small" [ngClass]="{ active: step === 2 }" (click)="goStep2()" [disabled]="form?.invalid">
            2. {{ 'OTHER.CONTACTS' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-container>
  </div>
</ng-container>
